import { render } from "./Runners.vue?vue&type=template&id=4daa15e2"
import script from "./Runners.vue?vue&type=script&lang=js"
export * from "./Runners.vue?vue&type=script&lang=js"
script.render = render

export default script